/*----------------------------------------------------------------
  Tiny utilities shared by every table component.
----------------------------------------------------------------*/

/** Convert snake_case → “Title Case” for friendlier column labels. */
export function improveColumnName(columnName: string): string {
    return columnName
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  
  /**
   * Normalise `maxHeight` so sticky-header tables always know how tall the
   * scroll-viewport may be.
   *
   * If the caller passes “80vh” or “calc(100vh - 200px)” we fall back to 700 px
   * (desktop default).  For a pixel string we subtract the header/footer
   * allowance so body rows do not vanish under sticky chrome.
   */
  export function calcTableBodyHeight(
    maxHeight: string,
    headerHeightPx = 48,
    footerHeightPx = 32
  ): string {
    if (maxHeight.includes("vh") || maxHeight.includes("calc")) {
      return "700px";
    }
    if (maxHeight.endsWith("px")) {
      const num = parseInt(maxHeight, 10);
      if (!Number.isNaN(num) && num > 100) {
        return `${num - headerHeightPx - footerHeightPx}px`;
      }
    }
    return maxHeight;
  }
  